import backendAxios from '../utils/backendAxios';

// Tickets del usuario autenticado (para dar seguimiento a sus solicitudes).
export const getMisTickets = async () => {
  const { data } = await backendAxios.get('/api/tickets/mios');
  return data;
};

export const getMiTicket = async (id) => {
  const { data } = await backendAxios.get(`/api/tickets/mios/${id}`);
  return data;
};

// Responde el ticket con texto y/o archivos adjuntos (multipart).
export const responderMiTicket = async (id, { texto = '', archivos = [] }) => {
  const fd = new FormData();
  fd.append('texto', texto);
  archivos.forEach((a) => fd.append('adjuntos', a));
  const { data } = await backendAxios.post(`/api/tickets/mios/${id}/mensajes`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return data;
};
